import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "../../api/constant";
import type {
    site,
    siteByIdResponse,
    siteResponse,
} from "@/interface/site.interface";

export const SiteService = {
    createSite: async (payload: site): Promise<siteResponse> => {
        const API = `${API_ENDPOINT.site}`;
        return callApi<siteResponse>(API, { method: "POST", data: payload });
    },

    getSite: async (params?: string): Promise<siteResponse> => {
        const API = `${API_ENDPOINT.site}${params ? `?${params}` : ""}`;
        return callApi<siteResponse>(API, { method: "GET" });
    },

    updateSite: async (payload: site, id: string): Promise<siteResponse> => {
        const API = `${API_ENDPOINT.site}/${id}`;
        return callApi<siteResponse>(API, { method: "PUT", data: payload });
    },

    deleteSite: async (id: string): Promise<siteResponse> => {
        const API = `${API_ENDPOINT.site}/${id}`;
        return callApi<siteResponse>(API, { method: "DELETE" });
    },

    getSiteById: async (id: string): Promise<siteByIdResponse> => {
        const API = `${API_ENDPOINT.site}/${id}`;
        return callApi<siteByIdResponse>(API, { method: "GET" });
    },
};
